import React, { useMemo } from "react";

const MessageReactions = ({ reactions }) => {
  const grouped = useMemo(() => {
    let items = reactions;

    // MySQL/Sequelize can return a JSON column as serialized text depending
    // on the driver configuration. Accept both forms so socket updates and a
    // full page reload render exactly the same reactions.
    if (typeof items === "string" && items) {
      try {
        items = JSON.parse(items);
      } catch (err) {
        items = [];
      }
    }

    if (!Array.isArray(items)) items = [];

    return items.reduce((result, reaction) => {
      if (!reaction?.emoji) return result;
      result[reaction.emoji] = (result[reaction.emoji] || 0) + 1;
      return result;
    }, {});
  }, [reactions]);

  const entries = Object.entries(grouped);
  if (!entries.length) return null;

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginTop: 5, marginBottom: 2 }}>
      {entries.map(([emoji, count]) => (
        <span
          key={emoji}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 3,
            padding: "1px 6px",
            borderRadius: 12,
            background: "rgba(127, 127, 127, 0.2)",
            fontSize: 14,
            lineHeight: "20px",
          }}
        >
          <span>{emoji}</span>
          {count > 1 && <span>{count}</span>}
        </span>
      ))}
    </div>
  );
};

export default MessageReactions;
